<template>
  <ComboboxItem
    ref="option"
    v-slot="{ selected }"
    :value="wrapper"
    :disabled="disabled"
    :aria-disabled="disabled || undefined"
    v-bind="$attrs"
    class="data-highlighted:bg-primary data-highlighted:text-on-primary relative flex cursor-pointer items-center gap-2 px-2 py-2 select-none"
    :class="
      muted && !highlighted ? 'dark:bg-surface/5 bg-gray-50 text-gray-500 dark:text-gray-400' : ''
    "
    @select="onSelect"
  >
    <span v-if="$slots['before-text']" class="flex items-center"><slot name="before-text" /></span>
    <slot name="text" :active="highlighted" :selected="selected">
      <span class="min-w-0 grow truncate" :class="{ 'font-semibold': selected }">{{
        text || wrapper.text
      }}</span>
    </slot>
    <span v-if="$slots['after-text']" class="flex shrink-0 items-center"
      ><slot name="after-text"
    /></span>
  </ComboboxItem>
</template>

<script setup lang="ts">
import { computed, inject, useTemplateRef, type ComponentPublicInstance } from "vue"
import { ComboboxItem, injectComboboxRootContext, injectListboxRootContext } from "reka-ui"
import type { CustomComboboxOptionWrapper } from "@/components/form/custom-combobox-option-wrapper"
import { inputComboxActionKey } from "./PInputComboxOptions.vue"

const props = defineProps<{
  wrapper: CustomComboboxOptionWrapper<any>
  text?: string
  disabled?: boolean
  muted?: boolean
}>()
const option = useTemplateRef<ComponentPublicInstance>("option")
const combobox = injectComboboxRootContext()
const listbox = injectListboxRootContext()
const selectAction = inject(inputComboxActionKey, undefined)
const highlighted = computed(() => option.value?.$el === listbox.highlightedElement.value)
function onSelect(event: Event) {
  event.preventDefault()
  if (props.disabled) return
  if (selectAction) {
    selectAction(props.wrapper)
    return
  }
  props.wrapper.onSelect(props.wrapper.item)
  combobox.onOpenChange(false)
}
defineOptions({ inheritAttrs: false })
</script>
